import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_DOCUMENT, CREATING_DOCUMENT, DOCUMENTS_ERROR, GETTING_DOCUMENTS, GET_DOCUMENTS, SIGNING_DOCUMENT, SIGN_DOCUMENT, UPDATE_DOCUMENT, UPDATING_DOCUMENT} from "../types"

export const createDocument = (documentPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_DOCUMENT,
            payload: true
        })
        const response = await axios.post(`${baseUrl}/documents`, documentPayload, { headers })
        
        dispatch({
            type: CREATE_DOCUMENT,
            payload: response.data.data
        })
        
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: DOCUMENTS_ERROR,
            // payload: error.response.data
            error
        })
    }
}

export const signDocument = (assignmentId, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: SIGNING_DOCUMENT,
            payload: true
        })
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/document-assignments/sign/${assignmentId}`, payload, { headers })
        
        dispatch({
            type: SIGN_DOCUMENT,
            payload: response.data.data
        }) 
        
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: DOCUMENTS_ERROR,
            // payload: error.response.data
            error
        })
    }
}

export const clearSignedDocument = () => async (dispatch) => {    
    dispatch({
        type: SIGN_DOCUMENT,
        payload: null
    })
}


export const fetchDocuments = (pagination, filters, sort, action) => async dispatch => {    
    try{
        const headers = authHeader()
        let requestUrl = 'documents'

        dispatch( {
            type: GETTING_DOCUMENTS,
            payload: true
        })

        // let appliedFilters =''
        // if (filters && filters!==null && filters.length > 0) {
        //     appliedFilters = parseFilters(filters, action, 'WALLETS')
        // }


        const response = await axios.get(`${baseUrl}/${requestUrl}`, { headers })
        // const response = await axios.get(`${process.env.REACT_APP_API_URL}/${requestUrl}?expand=custodian&limit=${pagination.perPage}&page=${pagination.page}&${appliedFilters}&${applySort(sort)}`, { headers })

        dispatch( {
            type: GET_DOCUMENTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: DOCUMENTS_ERROR,
            // payload: error.response.data,
            error
        })
    }
}

export const updateDocument = (documentId, documentPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_DOCUMENT,
            payload: true
        })
        const response = await axios.patch(`${baseUrl}/documents/${documentId}`, documentPayload, { headers })
        
        dispatch({
            type: UPDATE_DOCUMENT,
            payload: response.data.data
        })
        
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: DOCUMENTS_ERROR,
            // payload: error.response.data
            error
        })
    }
}

export const clearCreatedDocument = () => async (dispatch) => {    
    dispatch({
        type: CREATE_DOCUMENT,
        payload: null
    })
}

export const clearUpdatedDocument = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_DOCUMENT,
        payload: null
    })
}

